import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TablePagination,
  Box,
  IconButton,
  useMediaQuery,
  Theme,
  Typography,
  Tooltip,
  useTheme,
} from "@mui/material";
import { Edit} from "@mui/icons-material";
import { User} from "../userType/User"
import MapUserPopup from "./MapUserPopup"; 
import { useUserContext } from "../UserContext";
import CircularLoader from "../../../ui/elements/loader/CircularLoader";
import TableAvatar from "../../../ui/components/TableAvatar";

interface UsersTableProps {
  users: User[];
  open: boolean;
  setOpen: (open: boolean) => void;
  refetchUsers: () => void;
  selectedUsers: number[];
  setSelectedUsers: React.Dispatch<React.SetStateAction<number[]>>;
  setIsEdit: (open: boolean) => void;
  userLoading?: boolean;
}

const UserTable: React.FC<UsersTableProps> = ({ users, open, setOpen , refetchUsers, selectedUsers, setSelectedUsers, setIsEdit, userLoading}) => {
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
    const [selected, setSelected] = useState<number[]>([]);

    const {user}=useUserContext();

    const usersFiltered = users.filter(
      (item) => item.documentId !== user?.documentId
    );
     
    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        const allUserIds = users.map((user) => user.id); 
        setSelected(allUserIds);
      } else {
        setSelected([]); // Deselect all 
      }
    };
  
    const handleCheckboxClick = (id: number) => {
      setSelected((prevSelected) => {
        const isSelected = prevSelected.includes(id);
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((i) => i !== id);
        } else {
          // Select if not already selected
          return [...prevSelected, id];
        }
      });
    };
  
    const isSelected = (id: number) => selected.includes(id);  

    const handleEditClick = (user: User) => {
      setSelectedUsers([user.id]);
      setOpen(true); 
      setIsEdit(true);
    };

     const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px

  return (
    <Box
  sx={{
    paddingLeft: { xs: '10px', sm: '16px' },
    paddingRight: { xs: '10px', sm: '16px' },
    paddingBottom: { xs: '10px', sm: '0px' },
    paddingTop: '0px',
  }}
>
      <Box>
      <TableContainer component={Paper} elevation={0} sx={{
              height: isMobile ? "calc(100vh - 285px)" : "calc(100vh - 240px)",
              '&::-webkit-scrollbar': {
                width: '10px',
                height:'6px'
                
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#949494', 
                borderRadius: '8px',
              },

              '&::-webkit-scrollbar-track': {
                backgroundColor: 'rgba(242, 242, 242, 1)',
              },
            }}>
              {userLoading ? 
              <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <CircularLoader/> 
              </Box>:
            <Table stickyHeader aria-label="sticky table"  sx={{
              "& .MuiTableRow-root": {
                height: "36px",
              },
              "& .MuiTableCell-root": {
                padding: "4px",
                height: "51px",
                alignItems: "center",
              },
            }}>
              {usersFiltered.length<1 ?
               <TableRow>
               <TableCell colSpan={4} align="center" style={{ height: "100%" }}>
                 <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  No users found!!!
                 </Box>
               </TableCell>
             </TableRow> : 
                  <>
            <TableHead sx={{bgcolor:'#f0f0f0'}}>
              <TableRow>
                {/* <TableCell padding="checkbox" sx={{ minWidth: "50px" }}>
                <Checkbox
                    sx={{ color: "#00000099" }}
                    indeterminate={false}
                    checked={users.length > 0 && selected.length === users.length}
                    onChange={handleSelectAllClick}
                  />
                </TableCell> */}
                <TableCell align='center' sx={{ minWidth: "90px" }}>Action</TableCell>
                <TableCell sx={{ minWidth: "150px" }}>Users</TableCell>
                <TableCell sx={{ minWidth: "470px" }}>Exhibitors</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody >
            {usersFiltered?.map((user) => {
                const isItemSelected = isSelected(user.id);

                return (
                  <TableRow
                    key={user.id}
                    hover
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)', // Light grey on hover
                      },
                    }}
                  >
                    {/* <TableCell padding="checkbox">
                    <Checkbox
                        sx={{ color: "#00000099" }}
                        checked={isItemSelected}
                        onChange={() => handleCheckboxClick(user.id)}
                      />
                    </TableCell> */}
                  <TableCell align='center' >
                  <IconButton onClick={() => handleEditClick(user)}>
                          <Edit style={{ color: "black", fontSize: "18px" }} />
                  </IconButton>
                  </TableCell>

                  <TableCell>
                     <TableAvatar name={user.username} />
                  </TableCell>

                 <TableCell>
  {user.exhibitors && user.exhibitors.length > 0 && (
    <>
      {(() => {
        const maxVisible = isMobile ? 1 : isTablet ? 2 : 3;

        const visibleExhibitors = user.exhibitors.slice(0, maxVisible);
        const hiddenExhibitors = user.exhibitors.slice(maxVisible);

        return (
          <>
            {visibleExhibitors.map((exhibitor, index) => (
              <span key={exhibitor.id}>
                {exhibitor.name}
                {index !== visibleExhibitors.length - 1 && ", "}
              </span>
            ))}
            {hiddenExhibitors.length > 0 && (
              <Tooltip
                title={hiddenExhibitors.map((ex) => ex.name).join(", ")}
                arrow
              >
                <span style={{ color: "#000", cursor: "pointer" }}>
                  {" "}
                  (+{hiddenExhibitors.length})
                </span>
              </Tooltip>
            )}
          </>
        );
      })()}
    </>
  )}
</TableCell>
 
                </TableRow>
                 );
                })}
               
            </TableBody>
             </>
}
          </Table>
}
        </TableContainer>
      </Box>
    </Box>
  );
};

export default UserTable;
